import * as yup from "yup";
import { TAppPrefectureNames } from "../../types/TAppPrefectureNames";
import {
  ERROR_ENTRY_FORM_ADDRESS_FORMAT,
  ERROR_ENTRY_FORM_CITY_NAME_FORMAT,
  ERROR_ENTRY_FORM_HANKAKU_NUMBER_FORMAT,
  ERROR_ENTRY_FORM_HIRAGANA_FORMAT,
  ERROR_ENTRY_FORM_INSTAGRAM_FORMAT,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_ADDRESS2,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_ADDRESS3,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_CONTRACTOR_FIRSTNAME,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_CONTRACTOR_LASTNAME,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_FIRSTNAME,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_FIRSTNAME_KANA,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_INSTAGRAM,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_LASTNAME,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_LASTNAME_KANA,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_PASSWORD,
  ERROR_ENTRY_FORM_LENGTH_LIMIT_PHONE_NUMBER,
  ERROR_ENTRY_FORM_MISMATCHED_PASSWORD,
  ERROR_ENTRY_FORM_NAME_FORMAT,
  ERROR_ENTRY_FORM_PASSWORD_FORMAT,
  ERROR_ENTRY_FORM_POST_CODE_FORMAT,
  ERROR_ENTRY_FORM_REQURIRED_ADDRESS1,
  ERROR_ENTRY_FORM_REQURIRED_ADDRESS2,
  ERROR_ENTRY_FORM_REQURIRED_ADDRESS3,
  ERROR_ENTRY_FORM_REQURIRED_APPLY,
  ERROR_ENTRY_FORM_REQURIRED_FIRSTNAME,
  ERROR_ENTRY_FORM_REQURIRED_FIRSTNAME_KANA,
  ERROR_ENTRY_FORM_REQURIRED_LASTNAME,
  ERROR_ENTRY_FORM_REQURIRED_LASTNAME_KANA,
  ERROR_ENTRY_FORM_REQURIRED_PASSWORD,
  ERROR_ENTRY_FORM_REQURIRED_PASSWORDCONFIRM,
  ERROR_ENTRY_FORM_REQURIRED_PHONE_NUMBER,
  ERROR_ENTRY_FORM_REQURIRED_POST_CODE,
  ERROR_ENTRY_FORM_SPACE_FORMAT,
} from "../messages";

const schema = yup.object({
  sei: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_FIRSTNAME)
    .matches(/^[^\s]+$/, ERROR_ENTRY_FORM_SPACE_FORMAT)
    .matches(/^[ぁ-ゞァ-ヾ一-龥々-〇仝a-zA-Z]+$/, ERROR_ENTRY_FORM_NAME_FORMAT)
    .max(64, ERROR_ENTRY_FORM_LENGTH_LIMIT_FIRSTNAME)
    .trim(),
  mei: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_LASTNAME)
    .matches(/^[^\s]+$/, ERROR_ENTRY_FORM_SPACE_FORMAT)
    .matches(/^[ぁ-ゞァ-ヾ一-龥々-〇仝a-zA-Z]+$/, ERROR_ENTRY_FORM_NAME_FORMAT)
    .max(64, ERROR_ENTRY_FORM_LENGTH_LIMIT_LASTNAME)
    .trim(),
  kanaSei: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_FIRSTNAME_KANA)
    .matches(/^[^\s]*$/, ERROR_ENTRY_FORM_SPACE_FORMAT)
    .matches(/^[ぁ-ゞー・]+$/, ERROR_ENTRY_FORM_HIRAGANA_FORMAT)
    .max(64, ERROR_ENTRY_FORM_LENGTH_LIMIT_FIRSTNAME_KANA)
    .trim(),
  kanaMei: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_LASTNAME_KANA)
    .matches(/^[^\s]*$/, ERROR_ENTRY_FORM_SPACE_FORMAT)
    .matches(/^[ぁ-ゞー・]+$/, ERROR_ENTRY_FORM_HIRAGANA_FORMAT)
    .max(64, ERROR_ENTRY_FORM_LENGTH_LIMIT_LASTNAME_KANA)
    .trim(),
  contractorSei: yup
    .string()
    .default("") // デフォルト値を入れないと型定義でundefinedが推測されてしまう
    .matches(/^[^\s]*$/, ERROR_ENTRY_FORM_SPACE_FORMAT)
    .matches(
      /^[ぁ-ゞァ-ヾ一-龥々-〇仝a-zA-Z\s]*$/,
      ERROR_ENTRY_FORM_NAME_FORMAT
    )
    .max(64, ERROR_ENTRY_FORM_LENGTH_LIMIT_CONTRACTOR_FIRSTNAME)
    .trim(),
  contractorMei: yup
    .string()
    .default("") // デフォルト値を入れないと型定義でundefinedが推測されてしまう
    .matches(/^[^\s]*$/, ERROR_ENTRY_FORM_SPACE_FORMAT)
    .matches(
      /^[ぁ-ゞァ-ヾ一-龥々-〇仝a-zA-Z\s]*$/,
      ERROR_ENTRY_FORM_NAME_FORMAT
    )
    .max(64, ERROR_ENTRY_FORM_LENGTH_LIMIT_CONTRACTOR_LASTNAME)
    .trim(),
  // メールアドレスは仮登録メールで送信したものをAPIで取得し、readonlyで表示するため、バリデーションなし
  email: yup
    .string()
    .required(),
  tel: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_PHONE_NUMBER)
    .matches(/^[0-9]+$/, ERROR_ENTRY_FORM_HANKAKU_NUMBER_FORMAT)
    .min(10, ERROR_ENTRY_FORM_LENGTH_LIMIT_PHONE_NUMBER)
    .max(11, ERROR_ENTRY_FORM_LENGTH_LIMIT_PHONE_NUMBER)
    .trim(),
  zipcode: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_POST_CODE)
    .matches(/^\d{3}-?\d{4}$/, ERROR_ENTRY_FORM_POST_CODE_FORMAT)
    .trim(),
  prefName: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_ADDRESS1)
    .oneOf(TAppPrefectureNames, ERROR_ENTRY_FORM_REQURIRED_ADDRESS1),
  cityName: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_ADDRESS2)
    .matches(/^[^\s]+$/, ERROR_ENTRY_FORM_SPACE_FORMAT)
    .matches(/^[ぁ-ゞァ-ヾ一-龥々-〇仝\s]+$/, ERROR_ENTRY_FORM_CITY_NAME_FORMAT)
    .max(32, ERROR_ENTRY_FORM_LENGTH_LIMIT_ADDRESS2)
    .trim(),
  address: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_ADDRESS3)
    .matches(
      /^[ぁ-ゞァ-ヾ一-龥々-〇仝0-9a-zA-Z０-９ａ-ｚＡ-Ｚ-－ー−–ｰ\s]+$/,
      ERROR_ENTRY_FORM_ADDRESS_FORMAT
    )
    .min(3, ERROR_ENTRY_FORM_LENGTH_LIMIT_ADDRESS3)
    .max(255, ERROR_ENTRY_FORM_LENGTH_LIMIT_ADDRESS3)
    .trim(),
  instagramOwnerinput: yup
    .string()
    .default("") // デフォルト値を入れないと型定義でundefinedが推測されてしまう
    .matches(/^[a-zA-Z0-9._]*$/, ERROR_ENTRY_FORM_INSTAGRAM_FORMAT)
    .max(30, ERROR_ENTRY_FORM_LENGTH_LIMIT_INSTAGRAM)
    .trim(),
  password: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_PASSWORD)
    .min(8, ERROR_ENTRY_FORM_LENGTH_LIMIT_PASSWORD)
    .max(20, ERROR_ENTRY_FORM_LENGTH_LIMIT_PASSWORD)
    .matches(
      /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9!-~]+$/,
      ERROR_ENTRY_FORM_PASSWORD_FORMAT
    )
    .trim(),
  passwordConfirm: yup
    .string()
    .required(ERROR_ENTRY_FORM_REQURIRED_PASSWORDCONFIRM)
    .test(
      "confirmPassword",
      ERROR_ENTRY_FORM_MISMATCHED_PASSWORD,
      function (passwordConfirm, context) {
        if (passwordConfirm && passwordConfirm?.length > 0) {
          return context.parent.password === passwordConfirm;
        }
        return true;
      }
    )
    .trim(),
  apply: yup
    .boolean()
    .oneOf([true], ERROR_ENTRY_FORM_REQURIRED_APPLY)
    .required(ERROR_ENTRY_FORM_REQURIRED_APPLY),
});

export default schema;
